module.exports = __webpack_public_path__ + "img/logo.49e09258.png";